import { defineStore } from 'pinia';

export const useAAGStore = defineStore({
  id: 'aag',
  state: () => ({
    aagDashboard: [],
  }),
  getters: {
    aagDashboardGetter() {
      return this.aagDashboard;
    },
    aagFavoriteGetter() {
      if (!this.aagDashboard.length) return [];
      return this.aagDashboard.flatMap((aagItem) =>
        aagItem.IndicatorData.map((indicator) => ({
          DOSCode: indicator.DOSCode,
          IsGlobal: indicator.IsGlobal,   
        }))
      );
    },
  },
  actions: {
    async getAAGDashboard() {
      const response = await axios.get('/trendsreport/tr-my-aag-dashboard');
      this.aagDashboard = response.data;
    },
  },
});
